import { render, staticRenderFns } from "./Bag.vue?vue&type=template&id=7a09b5ab"
import script from "./Bag.vue?vue&type=script&lang=js"
export * from "./Bag.vue?vue&type=script&lang=js"
import style0 from "./Bag.vue?vue&type=style&index=0&id=7a09b5ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports